<template>
    <div class="checkout-contact width-limiter">
        <div v-for="item in userFields">
            <def-email
                v-if="item.CODE === 'EMAIL'"
                :name="item.inputName"
                :value="item.VALUE"
                :label="item.NAME"
                :required="item.REQUIRED === 'Y'"
                :key="item.CODE"
                @change="({target}) => setRequestData({ name: target.name, value: target.value })"
            />
            <DefPhone
                v-else-if="item.CODE === 'PHONE'"
                :name="item.inputName"
                :value="userPhone"
                :label="item.NAME"
                :required="item.REQUIRED === 'Y'"
                :key="item.CODE"
                @change="({target}) => setRequestData({ name: target.name, value: target.value })"
            />
<!--            @input="({target}) => setRequestData({ name: target.name, value: target.value })"-->
            <!--club card-->
            <CheckoutContactSovaClub
                v-else-if="item.CODE ===  'SOVA_CLUB'"
                :result="item"
            />

            <DefInput
                v-else-if="item.CODE !==  'CERTIFICATE'"
                :name="item.inputName"
                :value="item.VALUE || ''"
                :placeholder="item.NAME"
                :required="item.REQUIRED === 'Y'"
                :key="item.CODE"
                @change="({target}) => setRequestData({ name: target.name, value: target.value })"
            />
        </div>

        <div v-if="messages" class="processing-personal-data">
            <def-checkbox
                :required="true"
                :invalidText="messages.confirmPersonal"
                :checked="true"
            >
                {{ messages.agreement }}
                <DefLinkSecondary
                    v-if="messages.agreementLink"
                    :href="messages.agreementLink.href"
                    :line="'dashed'"
                >
                    {{ messages.agreementLink.title }}
                </DefLinkSecondary>
            </def-checkbox>
        </div>
        <CheckoutLogIn />
    </div>
</template>

<script>
import { mapState, mapMutations } from 'vuex';
import CheckoutContactSovaClub from "./CheckoutContactSovaClub";
import DefLinkSecondary from "../../def/DefLink/DefLinkSecondary";
import DefInput from "../../def/DefInput/DefInput";
import DefPhone from "../../def/DefPhone/DefPhone";

export default {
    name: 'CheckoutContact',
    selector: '.checkout-contact',
    props: ['result'],
    components: {
        DefInput,
        CheckoutContactSovaClub,
        DefLinkSecondary,
        DefPhone,
    },
    computed: {
        ...mapState({
            userFields: ({ checkout }) => checkout.data.vue.userFields.props,
            messages: ({ checkout }) => checkout.data.vue.messages,
            userPhone: ({ personal }) => personal.data.authInfo?.user_phone_number,
        }),
    },
    methods: {
        ...mapMutations({
            setRequestData: 'checkout/setRequestData',
        }),
    },
    mounted() {
        /** переопределение номера пользователя - замена последнего номера заказа на номер из кабинета пользователя */
        // this.userFields.forEach(el => {
        //     if (el.CODE === 'PHONE') this.setRequestData({ name: el.inputName, value: this.userPhone });
        // })
    }
}
</script>

<style lang="scss" scoped>
.checkout-contact{
    display: grid;
    grid-row-gap: 8px;

    @include point-md{
        position: relative;
    }
    :deep(.checkout-log-in) {
        margin-top: 24px;
        @include point-md{
            position: absolute;
            left: calc(100% + 32px);
            width: 100%;
            max-width: 232px;
            margin-bottom: unset;
        }
        @include point-lg{
            max-width: 130px;
        }
        @include point-xl{
            max-width: 300px;
        }
    }
    :deep(.def-input-component) {
        width: 100%;
    }
}
.processing-personal-data{
    margin-top: 8px;
    color: #191918;
    :deep(.def-checkbox + *:before) {
        top: -3px;
    }
    :deep(.def-checkbox + *:after){
        top: 2px;
    }
}
</style>